export default __webpack_public_path__ + "static/media/Gauge1.cd3fe8e3.jpg";